import type * as React from 'react';
import { postFormData } from '@Domain/Api';
import documentTemplateVersionUploaded, {
	type DocumentTemplateVersionUploadedAction,
	type DocumentTemplateVersionUploadedPayload,
} from '@Application/Documents/Templates/Actions/documentTemplateVersionUploaded';
import documentTemplateVersionUploadFailed, {
	type DocumentTemplateVersionUploadFailedAction,
} from '@Application/Documents/Templates/Actions/documentTemplateVersionUploadFailed';
import type UploadDocumentTemplateVersion from '@Application/Documents/Templates/Commands/UploadDocumentTemplateVersion';
import documentTemplateSectionDependenciesWarned, {
	type DocumentTemplateSectionDependenciesWarnedAction,
} from '@Application/Documents/Templates/Actions/documentTemplateSectionDependenciesWarned';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions =
	| DocumentTemplateVersionUploadedAction
	| DocumentTemplateVersionUploadFailedAction
	| DocumentTemplateSectionDependenciesWarnedAction;

export default (command: UploadDocumentTemplateVersion) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await postFormData<DocumentTemplateVersionUploadedPayload>(
				`${parameters.api.host}/api/organizations/${command.organizationId}/document-templates/${command.templateId}/versions`,
				command.toFormData(),
			);

			const action = documentTemplateVersionUploaded(payload);
			dispatch(action);

			const warningCount = payload.sectionDependencyWarnings.length;
			if (warningCount > 0) {
				dispatch(
					documentTemplateSectionDependenciesWarned({
						message: `${warningCount} dépendance(s) entre sections ne s'appliquent pas à ce gabarit.`,
					}),
				);
			}

			return action;
		} catch (error) {
			const action = documentTemplateVersionUploadFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
